
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1ycr2_99",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1ycr2_102",
  "sticky-background": "awsui_sticky-background_hyvsj_1ycr2_108",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_1ycr2_116",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1ycr2_129",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_1ycr2_139",
  "drawers-container": "awsui_drawers-container_hyvsj_1ycr2_151",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1ycr2_162",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1ycr2_185",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1ycr2_190",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1ycr2_231",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_1ycr2_241",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1ycr2_245",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_1ycr2_259",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1ycr2_245",
  "drawer": "awsui_drawer_hyvsj_1ycr2_151",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_1ycr2_290",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1ycr2_299",
  "drawer-content": "awsui_drawer-content_hyvsj_1ycr2_290",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_1ycr2_307",
  "drawer-slider": "awsui_drawer-slider_hyvsj_1ycr2_310",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1ycr2_317",
  "content": "awsui_content_hyvsj_1ycr2_343",
  "layout": "awsui_layout_hyvsj_1ycr2_364",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1ycr2_445",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1ycr2_460",
  "content-type-table": "awsui_content-type-table_hyvsj_1ycr2_474",
  "content-type-cards": "awsui_content-type-cards_hyvsj_1ycr2_474",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1ycr2_480",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_1ycr2_483",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1ycr2_515",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1ycr2_518",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1ycr2_528",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1ycr2_531",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1ycr2_534",
  "has-header": "awsui_has-header_hyvsj_1ycr2_534",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1ycr2_552",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1ycr2_552",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1ycr2_589",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1ycr2_589",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1ycr2_605",
  "unfocusable": "awsui_unfocusable_hyvsj_1ycr2_610",
  "container": "awsui_container_hyvsj_1ycr2_620",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1ycr2_646",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1ycr2_649",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1ycr2_649",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1ycr2_649",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_1ycr2_649",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1ycr2_658",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_1ycr2_675",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1ycr2_679",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1ycr2_683",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1ycr2_687",
  "navigation-container": "awsui_navigation-container_hyvsj_1ycr2_696",
  "show-navigation": "awsui_show-navigation_hyvsj_1ycr2_734",
  "animating": "awsui_animating_hyvsj_1ycr2_757",
  "showButtons": "awsui_showButtons_hyvsj_1ycr2_1",
  "navigation": "awsui_navigation_hyvsj_1ycr2_696",
  "openNavigation": "awsui_openNavigation_hyvsj_1ycr2_1",
  "animated-content": "awsui_animated-content_hyvsj_1ycr2_819",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1ycr2_828",
  "notifications": "awsui_notifications_hyvsj_1ycr2_838",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1ycr2_844",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1ycr2_861",
  "position-bottom": "awsui_position-bottom_hyvsj_1ycr2_908",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1ycr2_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1ycr2_937",
  "position-side": "awsui_position-side_hyvsj_1ycr2_950",
  "tools-container": "awsui_tools-container_hyvsj_1ycr2_972",
  "tools": "awsui_tools_hyvsj_1ycr2_972",
  "openTools": "awsui_openTools_hyvsj_1ycr2_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1ycr2_1063",
  "hide-tools": "awsui_hide-tools_hyvsj_1ycr2_1073",
  "show-tools": "awsui_show-tools_hyvsj_1ycr2_1085",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1ycr2_1063",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_1ycr2_1168",
  "trigger": "awsui_trigger_hyvsj_1ycr2_1168",
  "selected": "awsui_selected_hyvsj_1ycr2_1242",
  "badge": "awsui_badge_hyvsj_1ycr2_1262",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_1ycr2_1266",
  "dot": "awsui_dot_hyvsj_1ycr2_1277"
};
  